import React from 'react';
import cx from 'classnames';
import { csroles } from '../../../assets/CSroles';
import './index.scss';

// const domain = utils.getCookie('domain');
const getClassBasedLabel = (auth) => {
  if (auth.domain === 'FITNESS') {
    return 'ENROLLMENT';
  } else {
    return 'BOOKING';
  }
};

const getClassonLabel = (auth, typeofUser) => {
  return `NEW ${typeofUser}`;
};

const getUserTagsNotInCustomCount = (user_tags = [], custom_tags = []) => {
  const customTagIds = new Set(custom_tags.map((t) => String(t.id)));
  const uniqueUserIds = new Set(user_tags.map((t) => String(t.id)));

  let count = 0;
  uniqueUserIds.forEach((id) => {
    if (!customTagIds.has(id)) count++;
  });

  return count;
};

const Tags = ({ tags, auth, typeofUser, addTags, removeTag, removingTag, removingTagToUser, custom_tags, conversation, business, softwares, customTagDropdownVisibility }) => {
  const userTags = conversation?.details?.user_tags || [];
  const customTags = custom_tags || [];

  const remainingCustomTagsCount = customTags.length + getUserTagsNotInCustomCount(userTags, customTags);

  const shouldShowAddTag =
    !csroles.includes(auth?.role) &&
    customTags.length > 0 &&
    userTags.length < 2 &&
    userTags.length < remainingCustomTagsCount;
  return (
    <div className={cx('tags', {
      'more-tags': tags.length > 4,
    })}>
      {tags.length > 0 && <div className="description">Tags: </div>}
      {tags.map((tag) => {
        switch (tag) {
          case 'HAPPY':
            return (
              <span className="tag">
                <span className="tag__name">HAPPY CLIENT</span>
              </span>
            );

          case 'UNHAPPY':
            return (
              <span className="tag">
                <span className="tag__name">UNHAPPY CLIENT</span>
              </span>
            );

          case 'NEW':
            return (
              <span className="tag">
                <span className="tag__name">{getClassonLabel(auth, typeofUser)}</span>
              </span>
            );

          case 'BOOKING':
          case 'NEW_BOOKING':
            return (
              <span className="tag">
                <span className="tag__name">{getClassBasedLabel(auth)}</span>
              </span>
            );
          case 'RESCHEDULE':
            return (
              <span className="tag">
                <span className="tag__name">RESCHEDULE</span>
              </span>
            );
          case 'CANCELLATION':
            return (
              <span className="tag">
                <span className="tag__name">CANCELLATION</span>
              </span>
            );
          case 'IS_LANDLINE':
            return (
              <span className="tag">
                <span className="tag__name">LANDLINE</span>
              </span>
            );
          case 'LE_CAMPAIGN_IN_PROGRESS':
            return (
              <span className="tag">
                <span className="tag__name">CAMPAIGN IN PROGRESS</span>
              </span>
            );
          case 'LE_BOOKED_ON_TRUELARK':
            return (
              <span className="tag">
                <span className="tag__name">BOOKED ON TRUELARK</span>
              </span>
            );
          case 'LE_BOOKED_OFF_PLATFORM':
            return (
              <span className="tag">
                <span className="tag__name">BOOKED OFF PLATFORM</span>
              </span>
            );
          case 'LE_ENGAGED':
            return (
              <span className="tag">
                <span className="tag__name">ENGAGED</span>
              </span>
            );
          case 'LE_UNRESPONSIVE':
            return (
              <span className="tag">
                <span className="tag__name">UNRESPONSIVE</span>
              </span>
            );
          case 'LE_OPTED_OUT':
            return (
              <span className="tag">
                <span className="tag__name">OPTED OUT</span>
              </span>
            );
          case 'LE_EXPIRED_CAMPAIGN':
            return (
              <span className="tag">
                <span className="tag__name">EXPIRED CAMPAIGN</span>
              </span>
            );
          case 'USING_INSURANCE':
            return (
              <span className="tag">
                <span className="tag__name">USING INSURANCE</span>
              </span>
            );
          case 'OUT_OF_POCKET':
            return (
              <span className="tag">
                <span className="tag__name">PAY OUT OF POCKET</span>
              </span>
            );
          case 'UNRESPONSIVE':
            return (
              <span className="tag">
                <span className="tag__name">UNRESPONSIVE</span>
              </span>
            );
          case 'BOOKING_REQUEST':
            return (
              <span className="tag">
                <span className="tag__name">NEW BOOKING REQUEST</span>
              </span>
            );
          case 'RESCHEDULE_REQUEST':
            return (
              <span className="tag">
                <span className="tag__name">RESCHEDULE REQUEST</span>
              </span>
            );
          case 'CANCEL_REQUEST':
            return (
              <span className="tag">
                <span className="tag__name">CANCEL REQUEST</span>
              </span>
            );
          default:
            return null;
        }
      })}
      {conversation?.details?.user_tags?.map((tag) => {
        return (<span className={cx('custom-tag', { 'disable-tag': removingTag?.id === tag.id && removingTagToUser })} >
          <span className="custom-tag__name">{tag.name}</span>
          {!csroles.includes(auth?.role) && softwares?.bsw_id === tag?.associated_id && <i className="material-icons" onClick={() => removeTag(tag)}>close</i>}
        </span>);
      })}
      {shouldShowAddTag &&
        <div className="add-tag">
          <div className={cx({ 'add-tag_btn': customTagDropdownVisibility, 'add-tag_btn-inactive': !customTagDropdownVisibility })} onClick={() => addTags(true)}><i className="material-icons">add</i> ADD</div>
        </div>}
    </div>
  );
};

export default Tags;
